import { observable, action } from 'mobx';
import { randomID } from 'utils';

const insertToStore = (title, message, type) => {
  let id = randomID();
  return { id, title, message, type };
}

const limit = 1;

class AlertStore {
  @observable alerts = [];

  @action add (obj) {
    if (limit === this.alerts.length) {
      this.remove(this.alerts[0]);
    }

    this.alerts.push(obj);
  }

  @action remove (obj) {
    this.alerts.remove(obj);
  }

  @action success (title, message) {
    const obj = insertToStore(title, message, 'success');
    this.add(obj);
  }
  
  @action warning (title, message) {
    const obj = insertToStore(title, message, 'warning');
    this.add(obj);
  }

  @action error (title, message) {
    const obj = insertToStore(title, message, 'error');
    this.add(obj);
  }
}

export default new AlertStore();
